module.exports = __webpack_public_path__ + "cd0c955c8b8f5efdfdf7eca6a491c00f.pdf";